import { get, post } from 'redux/shelf/api';
import { create as createActions } from 'redux/shelf/actions';
import { createReducer } from 'redux/shelf/reducer';
import session from 'lib/session';
import { field } from 'redux/shelf';
import axios from 'axios';
import * as config from 'config';

const format = (r) =>
  r && r.styles && typeof r.styles === 'string'
    ? JSON.parse(r.styles)
    : r.styles;

const createRequest = (version) => {
  const url =
    process.env.NODE_ENV === 'development'
      ? `https://d3nhg2i1zayjpd.cloudfront.net/bundle/staging/${version}/raw.css`
      : `https://cdn.jsdelivr.net/npm/@findify/bundle@${version}/dist/raw.css`;
  return axios.get(url);
};
const getRawCss = (responseMapper) => {
  return createActions(`[rawCss]`, createRequest, responseMapper);
};

const rawRequest = createActions;
export const actions = {
  fetch: get`settings/${session.getMerchant}/assets/styles`(format),
  update: post`settings/${session.getMerchant}/assets/styles`(format),
  fetchRaw: getRawCss(field('raw')),
};

export const reducer = createReducer(actions);
